import type { EmployeeInfo, PermissionGroupInfo } from '../dtos/employee';

export class Employee {
  readonly id: number;
  readonly name: string;
  readonly email: string;
  readonly permissions: string[];

  constructor(params: Partial<Employee> & { id?: number }) {
    this.id = params.id ?? 0;
    this.name = params.name ?? '';
    this.email = params.email ?? '';
    this.permissions = params.permissions ?? [];
  }
}

export class PermissionGroup {
  readonly id: string;
  readonly group: string;
  readonly permissions: string[];

  constructor(params: Partial<PermissionGroup>) {
    this.group = params.group ?? '';
    this.id = this.group;
    this.permissions = params.permissions ?? [];
  }
}

export const EmployeeMapper = {
  fromDto(dto: EmployeeInfo): Employee {
    return new Employee({
      id: dto.id,
      name: dto.name,
      email: dto.email,
      permissions: dto.permissions ?? [],
    });
  },

  fromDtoList(dtos: EmployeeInfo[]): Employee[] {
    return (dtos ?? []).map((dto) => EmployeeMapper.fromDto(dto));
  },
};

export const PermissionGroupMapper = {
  fromDto(dto: PermissionGroupInfo): PermissionGroup {
    return new PermissionGroup({ group: dto.group, permissions: dto.permissions ?? [] });
  },

  fromDtoList(dtos: PermissionGroupInfo[]): PermissionGroup[] {
    return (dtos ?? []).map((dto) => PermissionGroupMapper.fromDto(dto));
  },
};
